import { useCallback } from "react";

/**
 * Custom hook for handling API errors and displaying them in error dialog
 */
export const useApiErrorHandler = (dispatch) => {
  return useCallback((response) => {
    if (response && response.error) {
      dispatch({ type: 'CLOSE_RESPONSE', payload: response });
    }
  }, [dispatch]);
};

